import React from 'react';
import InternalLayout, { Content, Sider, LayoutProps } from './layout';

interface LayoutType extends React.FC<LayoutProps> {
  Content: typeof Content;
  Sider: typeof Sider;
}

const Layout = InternalLayout as LayoutType;

Layout.Content = Content;
Layout.Sider = Sider;

export default Layout;
